// extracted by mini-css-extract-plugin
module.exports = {"bcg":"ErrorPage_bcg__15JII","title":"ErrorPage_title__2Ffhw","redirectLink":"ErrorPage_redirectLink__37kMb"};